// Rapor servisi - Rapor API çağrıları
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Rapor servis fonksiyonları
export const reportService = {
  // Müşteri raporu
  async getCustomerReport(params = {}) {
    try {
      const response = await api.get('/reports/customers', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Proje raporu
  async getProjectReport(params = {}) {
    try {
      const response = await api.get('/reports/projects', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcı raporu
  async getUserReport(params = {}) {
    try {
      const response = await api.get('/reports/users', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Toplantı raporu
  async getMeetingReport(params = {}) {
    try {
      const response = await api.get('/reports/meetings', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // İstatistik raporu
  async getStatisticsReport(params = {}) {
    try {
      const response = await api.get('/reports/statistics', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,

  // Teklif raporu
  async getOfferReport(params = {}) {
    try {
      const response = await api.get('/reports/offers', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
